import React from "react";
import TelegramIntegrationForm from "../../components/TelegramIntegrationForm/TelegramIntegrationForm";
import { useSelector } from "react-redux";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";

const IntegrationTgBotScreen = () => {
  const activeBot = useSelector((state) => state?.integration?.activeBot);

  return (
    <ScreenLayout>
      <TelegramIntegrationForm data={activeBot ? activeBot : null} />
    </ScreenLayout>
  );
};

export default IntegrationTgBotScreen;
